import { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/avenir-logo.png";
import { useAuth } from "../context/AuthContext";

const BANNER_HEIGHT = 72;

const MENU_ITEMS = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "PTS Updates", path: "/pts-updates" },
];

const AppShell = ({ children }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const goTo = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          top: 0,
          mb: 2,
          backgroundColor: "#23324c",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minHeight: BANNER_HEIGHT,
            height: BANNER_HEIGHT,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              aria-label="Open menu"
              onClick={() => setOpen(true)}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Box
              component="img"
              src={logo}
              alt="Avenir Collective"
              sx={{ height: 52, width: "auto" }}
            />
          </Box>
          <Button color="inherit" onClick={logout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          zIndex: (theme) => theme.zIndex.appBar - 1,
          "& .MuiDrawer-paper": {
            top: BANNER_HEIGHT,
            height: `calc(100% - ${BANNER_HEIGHT}px)`,
          },
        }}
        slotProps={{
          backdrop: {
            sx: { top: BANNER_HEIGHT },
          },
        }}
      >
        <List sx={{ width: 260 }} aria-label="Main menu">
          {MENU_ITEMS.map((item) => (
            <ListItemButton
              key={item.path}
              selected={location.pathname === item.path}
              onClick={() => goTo(item.path)}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      {children}
    </>
  );
};

export default AppShell;
